module.exports = __webpack_public_path__ + "img/will-robinson-rampage.0803c6d.jpg";